module.exports = __webpack_public_path__ + "static/media/survey_probe.9540f181.png";